<template>
    <BaseModal
        :id="'static-history-movement'"
        :title="`Room movement history of ${history_item.title}`"
        size="xl"
        :message="message !== undefined ? message : default_message"
        :link_message="link_message"
        :link_event="link_event"
        @linkEvent="linkEmitReceiver()"
    >
    
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>

        <template v-slot:content>
            <div class="w-100 table-responsive defaultproject__table overflow-y--2" v-if="historial_movements.length">
                <table class="table">
                    <thead>
                        <tr>
                            <th v-for="(item, i) in history_table_headers" :key="i" scope="col" v-html="item.name"/>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in historial_movements" :key="i">
                            <td v-html="item.associate"/>
                            <td v-html="item.change_made_on"/>
                            <td v-html="item.task"/>
                            <td v-html="item.type"/>
                            <td v-html="item.action"/>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal    from '@/components/BaseModal'
import Breadcrumb   from '@/components/BreadcrumbComponent/Breadcrumb'

export default {

    name: 'HistoryMovementModal',

    props: [
        'notyf',
        'message',
        'rest_api',
        'breadcrumb',
        'history_item',
        'link_event',
        'link_message'
    ],

    data() {
        return {
            history_table_headers: [
                { 
                    name:   'Change made by',
                },
                {   
                    name:   'Change made on',
                },
                {
                    name:   'Task',
                },
                {
                    name:   'Type Task'
                },
                {
                    name:   'Action',
                },
            ],

            historial_movements: [],
            default_message: `This record has a history of all the changes made to it since its creation. You can view each modification, including who made it and when it was made, by scrolling through the timeline below.`
        };
    },

    components: {
        BaseModal,
        Breadcrumb,
    },

    watch: {

        async 'history_item.id'(val)
        {
            this.historial_movements = []
           
            const room_id = val

            const json_request = {
                room_id,
                movement_historial: true,
            }

            this.loader(true)
            const response = await this.get(`${this.rest_api}/${JSON.stringify(json_request)}`)
            this.loader()

            if(response.status)
            {
                this.historial_movements = response.data.historial_movements

                if(!this.historial_movements.length)
                {
                    this.notyf.error('Empty Task movement history')
                }
            }
            else
            {
                this.error_handling(response)
            }
        }

    },

    methods: {

        async historialRefresh()
        {
            if(this.history_item.id === undefined)
            {
                return false
            }
            
            this.historial_movements = []
            
            const room_id = this.history_item.id

            const json_request = {
                room_id,
                movement_historial: true,
            }

            this.loader(true)
            let response = await this.get(`${this.rest_api}/${JSON.stringify(json_request)}`)
            this.loader()

            if(response.status)
            {
                this.historial_movements = response.data.historial_movements

                if(!this.historial_movements.length)
                {
                    this.notyf.error('Empty Room movement history')
                }
            }
            else
            {
                this.error_handling(response)
            }
        },

        linkEmitReceiver()
        {
            this.$emit('linkEventReceiver', true)
        },

    }
}
</script>